import React from "react";

export const AppleIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
  >
    <path
      d="M30.5073 12.7497C30.3159 12.8982 26.9367 14.8023 26.9367 19.0362C26.9367 23.9334 31.2366 25.6659 31.3653 25.7088C31.3455 25.8144 30.6822 28.0815 29.0982 30.3915C27.6858 32.4243 26.2107 34.4538 23.9667 34.4538C21.7227 34.4538 21.1452 33.1503 18.5547 33.1503C16.0302 33.1503 15.1326 34.4967 13.08 34.4967C11.0274 34.4967 9.5952 32.6157 7.9485 30.3057C6.0411 27.5931 4.5 23.379 4.5 19.3794C4.5 12.9642 8.6712 9.5619 12.7764 9.5619C14.9577 9.5619 16.776 10.9941 18.1455 10.9941C19.449 10.9941 21.4818 9.4761 23.9634 9.4761C24.9039 9.4761 28.2831 9.5619 30.5073 12.7497ZM22.7853 6.7602C23.8116 5.5425 24.5376 3.8529 24.5376 2.1633C24.5376 1.929 24.5178 1.6914 24.4749 1.5C22.8051 1.5627 20.8185 2.6121 19.6206 4.0014C18.6801 5.0706 17.8023 6.7602 17.8023 8.4729C17.8023 8.7303 17.8452 8.9877 17.865 9.0702C17.9706 9.09 18.1422 9.1131 18.3138 9.1131C19.812 9.1131 21.6963 8.1099 22.7853 6.7602Z"
      fill="#323232"
    />
  </svg>
);
